import * as React from 'react'

import {Button, TYPES} from './../shared/button'
import {createPdfReport, convertImage} from './../shared/utils'
import './../../styles/recordings/note.css'

var strftime = require('strftime')

class Note extends React.Component {

  licensePlateCheck = (num) => {
    if(num === null) {
      return 'No Plate Read'
    } else {
      return num
    }
  }

  runConvertImage = () => {
    const mainImage = this.refs.noteImage
    const secondaryImage = this.refs.fullImage
    let mainUrlImage, secondaryUrlImage
    mainUrlImage = convertImage(document, mainImage)
    if(secondaryImage) {
        secondaryUrlImage = convertImage(document, secondaryImage)
        createPdfReport(this.props.note, mainUrlImage, secondaryUrlImage, this.props.license_plate)
    } else {
      createPdfReport(this.props.note, mainUrlImage, null, this.props.license_plate)
    }
  }

  render () {
    const {note} = this.props
    return (
      <div className='view-note'>
        <div className='view-note-left'>
          <h1>View Note</h1>
          <div className='view-details-left'>
            <h3>{note.title}</h3>
            <h5>Damage Description:</h5>
            {note.description}
            <h5>Reviewer:</h5>{note.reviewer}
            {note.zoom_image &&
              <div>
                <h5>Full Image:</h5>
                <img src={note.zoom_image} alt='Damage' ref='fullImage' crossOrigin='anonymous' id='full-image'/>
              </div>
            }
          </div>
        </div>
        <div className='view-note-right'>
          <div className='view-details-right'>
            <div className='view-data-right'>
              <h5>Date:</h5>
              <p>{strftime('%B %d, %Y %I:%M %p', new Date(note.created_at))}</p>
              <h5>License Plate:</h5>
              <p>{this.licensePlateCheck(this.props.license_plate)}</p>
            </div>
            <Button
              text='Download PDF'
              type='viewNote'
              onClick={() => this.runConvertImage()}
              buttonType={TYPES.DEFAULT}
            />
          </div>
          <img src={note.image} alt='Damage' ref='noteImage' crossOrigin='anonymous' id='zoom-image'/>
        </div>
      </div>
    )
  }
}

export default Note



// WEBPACK FOOTER //
// ./src/components/note/note.js